module.exports = __webpack_public_path__ + "static/media/desktopScreenshot03.8c628193.jpg";